import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { DataElement } from '../../components/data-element/data-element.component';
import { DateTimeDisplay } from '../../components/date-time-display/date-time-display.component';
import { ElementWrapper } from '../../components/element-wrapper/element-wrapper.component';
import { PageContentWrapper } from '../../components/page-content-wrapper/page-content-wrapper.component';
import { PageHeader } from '../../components/page-header/page-header.component';
import { ValidationError } from '../../components/validation-error/validation-error.component';
import { useAuth } from '../../contexts/UserContext';
import { ApiService } from '../../services/api';
import { ApiError } from '../../services/api/core/ApiError';
import { Alert } from '../../services/api/models/Alert';

export const UnitEvent: FC = () => {
  const [event, setEvent] = useState<Alert | null>();
  const { unitId, eventId } = useParams();

  const { logout } = useAuth();

  useEffect(() => {
    const fetchAlerts = async () => {
      if (unitId && eventId) {
        try {
          const alerts = await ApiService.getAlertHistory(Number(unitId));
          setEvent(alerts[Number(eventId)] || null);
        } catch (e) {
          if (e instanceof ApiError && (e.status === 400 || e.status === 401 || e.status === 403)) {
            logout();
          }
        }

      }
    }
    fetchAlerts();
  }, [eventId]);


  return (
    <div className="flex flex-1 flex-col">
      <PageHeader title="Asset Location" showBack />
      <PageContentWrapper>
        {
          event === undefined
            ?
            <h3>Loading...</h3>
            :
            event === null
              ?
              <ValidationError>Cannot find event</ValidationError>
              :
              <div className="flex flex-col gap-2">
                <h3 className="font-bold mb-3">Event View</h3>
                <ElementWrapper title="Event Time">
                  <DateTimeDisplay isoDate={event.alertDate} enlarge />
                </ElementWrapper>
                <DataElement title="Event Type" body={String(event.alertType)} />
                <DataElement title="Event Data" body={String(event.alertDescription)} />
              </div>

        }
      </PageContentWrapper>
    </div >
  );
};
